import { Input as AppInput } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ error, className, ...rest }, ref) => {
  return (
    <div>
      <AppInput
        ref={ref}
        {...rest}
        className={cn(
          'h-12 px-4 text-base',
          {
            'border-red-500 focus-within:border-red-500 focus:border-red-500 focus-visible:border-red-500':
              error,
          },
          className,
        )}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
